import React from 'react';
import { Text, View } from 'react-native';
import { rem } from 'design-system';
import { styles } from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const NotificationCount = ({ count, top, ...props }) => {
    const styles = useStyles(styleSet);
    if (!count || count === 0) {
        return null;
    }
    return (<View style={[styles.notificationIconTextContainer, { top, ...props }]} accessibilityRole="text" accessibilityLabel={`${count} unread notifications`}>
      <Text style={styles.notificationIconText}>
        {count > 999 ? '999+' : count}
      </Text>
    </View>);
};
export default NotificationCount;
const styleSet = createStyleSheets((colors) => ({
    notificationIconTextContainer: {
        borderRadius: rem(14),
        position: 'absolute',
        backgroundColor: colors.elements.statusNegative,
        height: rem(14),
        minWidth: rem(14),
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: rem(4),
    },
    notificationIconText: {
        ...styles.Text_10,
        lineHeight: rem(14),
        width: '100%',
        color: colors.text.white,
        textAlign: 'center',
        alignSelf: 'center',
    },
}));
